import { useEffect, useState } from "react";
import { Row, Col, Spin, message } from "antd";
import {
    ClockCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    HourglassOutlined,
} from "@ant-design/icons";

import { getTicketCounts } from "./ticketApi";
import StatisticCard from "./StatisticCard";
import axios from 'axios';

interface TicketCounts {

    open: number;

    inProgress: number;

    assigned: number;

    resolved: number;

    closed: number;

}
interface StatisticsProps {
    refreshKey: number;
    onStatusSelect: (status: string) => void;
}
export default function Statistics({
    refreshKey,
    onStatusSelect,
}: StatisticsProps) {

    const [counts, setCounts] =
        useState<TicketCounts>({
            open: 0,
            inProgress: 0,
            assigned: 0,
            resolved: 0,
            closed: 0,
        });

    const [loading, setLoading] =
        useState(false);

    useEffect(() => {
    loadStatistics();
}, [refreshKey]);

    const loadStatistics = async () => {

        try {

            setLoading(true);

            const response =
                await getTicketCounts();

            setCounts(response);

        } catch (error) {

            console.error(error);
           

            message.error(
                "Unable to load ticket statistics."
            );

        } finally {

            setLoading(false);

        }

    };

    const inProgress =
        (counts.inProgress ?? 0) +
        (counts.assigned ?? 0);

    const statistics = [
    {
        title: "Open",
        value: counts.open,
        icon: <ClockCircleOutlined />,
        color: "#1677ff",
        status: "OPEN",
    },

    {
        title: "In Progress",
        value: inProgress,
        icon: <HourglassOutlined />,
        color: "#faad14",
        status: "IN_PROGRESS",
    },

    {
        title: "Resolved",
        value: counts.resolved,
        icon: <CheckCircleOutlined />,
        color: "#52c41a",
        status: "RESOLVED",
    },

    {
        title: "Closed",
        value: counts.closed,
        icon: <CloseCircleOutlined />,
        color: "#722ed1",
        status: "CLOSED",
    },
];
    if (loading) {

        return (

            <Row
                justify="center"
                style={{
                    padding: 40,
                }}
            >

                <Spin size="large" />

            </Row>

        );

    }

    return (

        <Row gutter={[20, 20]}>
    {statistics.map((item) => (
        <Col
            xs={24}
            sm={12}
            md={12}
            lg={6}
            key={item.title}
        >
            <StatisticCard
                title={item.title}
                value={item.value}
                icon={item.icon}
                color={item.color}
                onClick={() => onStatusSelect(item.status)}
            />
        </Col>
    ))}
</Row>
    );

}